module.exports = __webpack_public_path__ + "img/nz.30299530.svg";